import * as route from "../routes/constants";
import { sportTypes } from "../config/sport-types";
import { createURL } from "../utils/menus";

const root = "/canli-bahisler";

const markets = {
    ilkyari_10: {
        label: "İlk Yarı Ekranı - 10 Maç",
        slug: "ilk-yari-10",
        translateKey: "ilkyari_10"
    },
    ilkyari_13: {
        label: "İlk Yarı Ekranı - 13 Maç",
        slug: "ilk-yari-13",
        translateKey: "ilkyari_13"
    },
    macgenel_7: {
        label: "Maç Geneli Ekranı - 7 Maç",
        slug: "mac-genel-7",
        translateKey: "macgenel_7"
    },
    macgenel_10: {
        label: "Maç Geneli Ekranı - 10 Maç",
        slug: "mac-genel-10",
        translateKey: "macgenel_10"
    },
    macgenel_13: {
        label: "Maç Geneli Ekranı - 13 Maç",
        slug: "mac-genel-13",
        translateKey: "macgenel_13"
    },
    goloyunlari_7: {
        label: "Gol Oyunları Ekranı - 7 Maç",
        slug: "gol-oyunlari-7",
        translateKey: "goloyunlari_7"
    }
};

const LiveSubMenuItems = [
    {
        label: sportTypes.futbol.label,
        path: route.LIVE_FOOTBALL,
        icon: "football",
        translateKey:"futbol",
        children: [
            {
                label: markets.ilkyari_13.label,
                path: createURL(root, sportTypes.futbol.slug, markets.ilkyari_13.slug),
                translateKey: markets.ilkyari_13.translateKey
            },
            {
                label: markets.macgenel_13.label,
                path: createURL(root, sportTypes.futbol.slug, markets.macgenel_13.slug),
                translateKey: markets.macgenel_13.translateKey
            },
            {
                label: markets.macgenel_7.label,
                path: createURL(root, sportTypes.futbol.slug, markets.macgenel_7.slug),
                translateKey: markets.macgenel_7.translateKey
            },
            {
                label: markets.goloyunlari_7.label,
                path: createURL(root, sportTypes.futbol.slug, markets.goloyunlari_7.slug),
                translateKey: markets.goloyunlari_7.translateKey
            }
        ]
    },
    {
        label: sportTypes.basketbol.label,
        path: route.LIVE_BASKETBALL,
        icon: "basketball",
        translateKey:"basketbol",
        children: [
            {
                label: markets.ilkyari_13.label,
                path: createURL(root, sportTypes.basketbol.slug, markets.ilkyari_13.slug),
                translateKey: markets.ilkyari_13.translateKey
            },
            {
                label: markets.macgenel_13.label,
                path: createURL(root, sportTypes.basketbol.slug, markets.macgenel_13.slug),
                translateKey: markets.macgenel_13.translateKey
            },
            {
                label: markets.ilkyari_10.label,
                path: createURL(root, sportTypes.basketbol.slug, markets.ilkyari_10.slug),
                translateKey: markets.ilkyari_10.translateKey
            },
            {
                label: markets.macgenel_10.label,
                path: createURL(root, sportTypes.basketbol.slug, markets.macgenel_10.slug),
                translateKey: markets.macgenel_10.translateKey
            }
        ]
    },
    {
        label: sportTypes.tenis.label,
        path: route.LIVE_TENNIS,
        icon: "tennis",
        translateKey:"tenis",
    },
    {
        label: sportTypes.voleybol.label,
        path: route.LIVE_VOLLEYBALL,
        icon: "volleyball",
        translateKey:"voleybol",
    },
    {
        label: sportTypes.karma.label,
        path: route.LIVE_MIXED,
        icon: "mixed",
        translateKey:"mixed",
    }
];

export default LiveSubMenuItems;
